export interface VehicleSpecification {
  label: string
  value: string
}

type Vehicle = Record<string, unknown>

function numberValue(value: unknown): number | null {
  if (value === null || value === undefined || value === '') return null
  const number = typeof value === 'number' ? value : Number(String(value).replace(',', '.'))
  return Number.isFinite(number) ? number : null
}

function textValue(value: unknown): string | null {
  if (value === null || value === undefined) return null
  const text = String(value).trim()
  return text || null
}

function withUnit(value: unknown, unit: string): string | null {
  const number = numberValue(value)
  return number === null ? null : `${new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(number)} ${unit}`
}

function registrationDate(value: unknown): string | null {
  if (!value) return null
  const date = new Date(String(value))
  if (Number.isNaN(date.getTime())) return null
  return new Intl.DateTimeFormat('it-IT', {
    day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'Europe/Rome',
  }).format(date)
}

export function getRentToBuySpecifications(vehicle: Vehicle, unavailable: string): VehicleSpecification[] {
  const kw = withUnit(vehicle.kw, 'kW')
  const cv = withUnit(vehicle.cv, 'CV')
  const power = [kw, cv].filter(Boolean).join(' · ') || null
  const wheelbase = numberValue(vehicle.passo)
  const values: [string, string | null][] = [
    ['Cilindrata', withUnit(vehicle.cilindrata, 'cc')],
    ['Potenza', power],
    ['Trazione', textValue(vehicle.trazione)],
    ['Motore', textValue(vehicle.motore)],
    ['Numero marce', textValue(vehicle.numeroMarce)],
    ['Pneumatici', textValue(vehicle.pneumatici)],
    ['Lunghezza', withUnit(vehicle.lunghezza, 'cm')],
    ['Larghezza', withUnit(vehicle.larghezza, 'cm')],
    ['Altezza', withUnit(vehicle.altezza, 'cm')],
    ['Passo', wheelbase === null ? null : `${new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(wheelbase / 100)} m`],
    ['Porte', textValue(vehicle.porte)],
    ['Immatricolazione', registrationDate(vehicle.immatricolazione)],
    ['Chilometraggio', withUnit(vehicle.km, 'km')],
    ['Alimentazione', textValue(vehicle.alimentazione)],
    ['Cambio', textValue(vehicle.cambio)],
    ['Colore', textValue(vehicle.colore)],
  ]
  return values.map(([label, value]) => ({ label, value: value ?? unavailable }))
}

export function getRentToBuyOptions(value: unknown): string[] {
  if (!Array.isArray(value)) return []
  return value.filter((item): item is string => typeof item === 'string')
    .map((item) => item.trim())
    .filter(Boolean)
}
